import React from "react";
import Loader from "../../components/Loader";
import styles from "./LoadingScreen.module.css";

const LoadingScreen = () => {
  return (
    <div className={styles.container}>
      <Loader />
      <p>Loading Webform Please wait...</p>
    </div>
  );
};

export default LoadingScreen;
